// @ts-nocheck

import { PreviousPagesStateActionTypes } from '../types/actions/previouspages';

export const setPreviousPage = (page, { pageNumber, anchorId }) => ({
  type: PreviousPagesStateActionTypes.SET_PREVIOUS_PAGE,
  payload: { page, pageNumber, anchorId },
});

export const resetPreviousPage = (page) => ({
  type: PreviousPagesStateActionTypes.RESET_PREVIOUS_PAGE,
  payload: { page },
});

export default {
  setPreviousPage,
  resetPreviousPage,
};
